// import { Doctor } from './doctor.model';
import { CertificateBackground } from './certificate-background.model';
import { Presenter } from './presenter.model';

export class Answer {
    answerId: string;
    answerText: string;
    checked: boolean;
}

export enum QuestionType {
    SINGLE_ANSWER,
    MULTIPLE_ANSWERS,
    FREE_TEXT,
    YES_NO,
}

export class Question {
    questionTitle: string;
    questionId: string;
    userAnswer: number; // id of correct answer
    userAnswers: number[];
    correctAnswers: string[];
    correctAnswer: string;
    answers: Answer[];
    questionType: QuestionType;
}

export class Questionnaire {
    questionnaireId: string;
    videoId: number;
    questions: Question[];
    title: string;
    caption: string;
    activityTopic: string;
    levelOfActivity: string;
    level1: boolean;
    level2: boolean;
    ethics: boolean;
    dateOfActivity: Date;
    accreditationNumber: string;
    certificateBackground: CertificateBackground;
    markets: string[];
    hcpTypes: string[];
    isActive: boolean;
    isDeleted: boolean;
    presenter: Presenter;
    presenter2: Presenter;
    cpdPointAccreditation: string;
    accreditationType: string;
    videoLength: string;
    expiryDate: Date;
    passRate: number;
    areasOfInterest: string[];
    tags: string;
    activityType: string;

    showThumbnail: boolean;
    showTitle: boolean;
    showActivityType: boolean;
    showIconTray: boolean;
    showExpiry: boolean;
    showCPDPoints: boolean;
    showButton: boolean;
    showPresenter: boolean;
    showCaption: boolean;

    overrideButtonText: string;
    overrideExpiryDateText: string;
    overrideCPDPointsText: string;

    enableMustWatchVideoToSeeQuestions: boolean;
    enableCertificate: boolean;

    enableVideo: boolean;
    enableHtml: boolean;
    enablePdf: boolean;
    enableQuestions: boolean;

    activityThumbnailUrl: string;
    videoUrl: string;
    webinarUrl: string;
    pdfUrl: string;

    brand: string;

    webinarStartDateTime: string;

    questionnaireStatus: string;
    newLaunches: boolean;
    sortOrder: number;
    html: string;
}

export class CompletedQuestionnaire {
    completedBy: string;
    questionnaireId: string;
    dateCompleted: Date;
    score: number;
    market: string;
    fullName: string;
    completedQuestionnaireId: string;
}

export class SavedResponse {
    questionnaireId: string;
    userId: string;
    completedForm: any;
}
